export interface VulnerabilityPackagesQueryOptions {
  limit?: number;
  offset?: number;
  sortOrder?: 'asc' | 'desc';
  orderBy: 'packages' | 'Packages' | 'licenses';
}
